import { HugeiconsIcon, type IconSvgElement } from '@hugeicons/react';
import {
  forwardRef,
  type ForwardRefExoticComponent,
  type RefAttributes,
  type SVGProps,
} from 'react';

export type { IconSvgElement };

export type TerraIconProps = SVGProps<SVGSVGElement> & {
  size?: number | string;
  strokeWidth?: number;
  absoluteStrokeWidth?: boolean;
  color?: string;
};

export type TerraIcon = ForwardRefExoticComponent<
  TerraIconProps & RefAttributes<SVGSVGElement>
>;

type CreateTerraIconParams = {
  icon: IconSvgElement;
  displayName: string;
};

const DEFAULT_STROKE_WIDTH = 1.8;

export const createTerraIcon = ({
  icon,
  displayName,
}: CreateTerraIconParams): TerraIcon => {
  const Component = forwardRef<SVGSVGElement, TerraIconProps>(
    ({ color, style, strokeWidth = DEFAULT_STROKE_WIDTH, ...props }, ref) => (
      <HugeiconsIcon
        icon={icon}
        color={color}
        style={color === undefined ? style : { color, ...style }}
        strokeWidth={strokeWidth}
        {...props}
        ref={ref}
      />
    ),
  );
  Component.displayName = displayName;
  return Component;
};
